import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { publicIdSchema } from "./public-id";
import { visitResultSchema } from "./visit";

const version = z.string().regex(/^[0-9a-f]{64}$/);
const params = z.strictObject({
  public_id: publicIdSchema,
});
export const visitAudioSchema = z.object({ version });
export const visitAudioReplaceSchema = z.strictObject({
  audioUploadId: z.uuid().toLowerCase(),
  baseVersion: version,
});
export type VisitAudioReplaceBody = z.output<typeof visitAudioReplaceSchema>;
const resource = oc.errors({
  BAD_REQUEST: { message: "Invalid request" },
  UNAUTHORIZED: { message: "Authentication required" },
  FORBIDDEN: { message: "Account required" },
  NOT_FOUND: { message: "Visit not found" },
  CONFLICT: { message: "Audio attachment conflict" },
  SERVICE_UNAVAILABLE: { message: "Audio attachment unavailable" },
  METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
  INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
});
export const visitAudioContract = {
  getVisitAudio: resource
    .input(
      z.object({
        params,
        query: z.strictObject({}).default({}),
        body: z.undefined().optional(),
      }),
    )
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/visits/{public_id}/audio",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(visitAudioSchema),
  replaceVisitAudio: resource
    .input(
      z.object({
        params,
        query: z.strictObject({}).default({}),
        headers: z.object({ "idempotency-key": z.uuid().toLowerCase() }),
        body: visitAudioReplaceSchema,
      }),
    )
    .meta(
      openapi({
        method: "PUT",
        path: "/api/v2/visits/{public_id}/audio",
        inputStructure: "detailed",
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(visitResultSchema),
};
